<template>
  <div>
    <PCHeader
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :titleObj="titleObj"
    >
    </PCHeader>
    <div class="ad-container">
      <div class="ad-title">
        <h3>合作行业</h3>
        <span></span>
      </div>
      <div class="ad-text">寻找以下行业进行广告投放合作</div>

      <div class="ad-content">
        <div class="cooperation">
          <div class="cooperation-item" v-for="(item, index) in cooperation" :key="index">
            <div class="title">{{ item.title }}</div>
            <img :src="item.img" class="img" alt="" />
            <img :src="item.indexIcon" class="index" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="ad-container" style="background: #f7f7f7">
      <div class="ad-title">
        <h3>投放广告位</h3>
        <span></span>
      </div>

      <div class="ad-content">
        <div class="put-in">
          <div class="item" v-for="(item, index) in putin" :key="index">
            <img src="../../static/images/ad/b-img.png" class="b-img" alt="" />
            <img :src="item.img" class="img" alt="" />
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="ad-container">
      <div class="ad-title">
        <h3>广告投放内容</h3>
        <span></span>
      </div>
      <div class="ad-text">案例示范，为商家提供最有效的宣传方案</div>

      <div class="swiper-tabs">
        <div
          class="tab"
          :class="tabIndex === index ? 'active' : ''"
          v-for="(item, index) in tabs"
          :key="index"
          @click="tabClick(index)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="ad-content">
        <div class="swiper-container ad-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in putcontent" :key="index">
              <div class="putcontent-item">
                <div class="left">
                  <img :src="img" alt="" v-for="(img, i) in item.imgs" :key="i" />
                </div>
                <div class="right">
                  <div class="content-title">
                    <span>{{ item.title }}</span>
                    <div class="dot"></div>
                  </div>
                  <div class="desc">
                    {{ item.desc }}
                  </div>
                  <div class="c-list">
                    <div class="c-item" v-for="(c, j) in item.contents" :key="j">
                      <div class="c-title">{{ c.title }}</div>
                      <div class="c-content">
                        {{ c.content }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="putcontent-bg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ad-container">
      <div class="ad-title">
        <h3>合作优势</h3>
        <span></span>
      </div>

      <div class="ad-content">
        <div class="advantage">
          <div class="item" v-for="(item,index) in advantage" :key="index">
            <img :src="item.img" class="img" alt="">
            <div class="advantage-content" v-html="item.content">
            </div>
            <img :src="item.indexIcon" class="index-icon" alt="">
          </div>
        </div>
      </div>
    </div>

    <partner :partnerInfo="partner" ref="partnerRef"></partner>

    <HomeAdvisory></HomeAdvisory>
    <PCFooter
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :productType="productType"
    >
    </PCFooter>
  </div>
</template>
<script>
import Swiper from "swiper";

import PCHeader from "@/components/pc/Header";
import PCFooter from "@/components/pc/Footer";
import Partner from "@/components/pc/Partner";
import HomeAdvisory from "@/components/pc/HomeAdvisory";


// 合作行业图标
import cooperation_1 from "@/static/images/ad/cooperation_1.png";
import cooperation_2 from "@/static/images/ad/cooperation_2.png";
import cooperation_3 from "@/static/images/ad/cooperation_3.png";
import cooperation_4 from "@/static/images/ad/cooperation_4.png";
import cooperation_index_1 from "@/static/images/ad/cooperation_index_1.png";
import cooperation_index_2 from "@/static/images/ad/cooperation_index_2.png";
import cooperation_index_3 from "@/static/images/ad/cooperation_index_3.png";
import cooperation_index_4 from "@/static/images/ad/cooperation_index_4.png";

// 投放广告位图标
import puting_1 from "@/static/images/ad/puting_1.png";
import puting_2 from "@/static/images/ad/puting_2.png";
import puting_3 from "@/static/images/ad/puting_3.png";
import puting_4 from "@/static/images/ad/puting_4.png";

// 投放广告内容
import putcontent_1 from "@/static/images/ad/putcontent_1.png";
import putcontent_2 from "@/static/images/ad/putcontent_2.png";
import putcontent_3 from "@/static/images/ad/putcontent_3.png";
import putcontent_4 from "@/static/images/ad/putcontent_4.png";
import putcontent_5 from "@/static/images/ad/putcontent_5.png";
import putcontent_6 from "@/static/images/ad/putcontent_6.png";
import putcontent_7 from "@/static/images/ad/putcontent_7.png";
import putcontent_8 from "@/static/images/ad/putcontent_8.png";

// 合作优势
import advantage_1 from '@/static/images/ad/advantage_1.png'
import advantage_2 from '@/static/images/ad/advantage_2.png'
import advantage_3 from '@/static/images/ad/advantage_3.png'
import advantage_index_1 from '@/static/images/ad/advantage_index_1.png'
import advantage_index_2 from '@/static/images/ad/advantage_index_2.png'
import advantage_index_3 from '@/static/images/ad/advantage_index_3.png'

import bg from '@/static/images/ad/bg.png'

export default {
  name: "Custom",
  data() {
    return {
      screenStyle: {
        width: "",
        margin: "0 auto",
      },
      topStyle: "background-image:url('" + bg + "')",
      actIndex: 9,
      imgList: [],
      logo: "",
      productType: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      background: require("../../static/images/custom_develop/banner.png"),
      titleObj: {},
      partner: [],
      cooperation: [
        {
          title: "共享充电行业",
          img: cooperation_1,
          indexIcon: cooperation_index_1,
        },
        {
          title: "广告屏幕机行业",
          img: cooperation_2,
          indexIcon: cooperation_index_2,
        },
        {
          title: "收银一体机与台卡行业",
          img: cooperation_3,
          indexIcon: cooperation_index_3,
        },
        {
          title: "自动售货机行业",
          img: cooperation_4,
          indexIcon: cooperation_index_4,
        },
      ],
      putin: [
        {
          title: "H5/小程序弹窗",
          img: puting_1,
        },
        {
          title: "缴费页面banner",
          img: puting_2,
        },
        {
          title: "订单确认页banner",
          img: puting_3,
        },
        {
          title: "支付完成页banner",
          img: puting_4,
        },
      ],
      tabs: [
        {
          title: "权益包广告",
        },
        {
          title: "移动积分广告",
        },
        {
          title: "充电立减券广告",
        },
        {
          title: "视听会员广告",
        },
      ],
      tabIndex: 0,
      putcontent: [
        {
          imgs: [putcontent_1, putcontent_2],
          title: "权益包广告",
          desc:
            "权益包广告包含停车券和充电券数张，用户接触广告后点击进行付费开通，每月扣费获取券。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner，公众号菜单栏",
            },
            {
              title: "结算方式",
              content: "以CPA方式结算，按购买转化数据进行返佣",
            },
          ],
        },
        {
          imgs: [putcontent_3, putcontent_4],
          title: "移动积分广告",
          desc:
            "以停车券为广告噱头，通过移动积分兑换停车券，输入手机号快速兑换，广告营销维系移动用户，且消耗移动积分。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner",
            },
            {
              title: "结算方式",
              content: "按CPM方式结算，每千次曝光计费一次",
            },
          ],
        },
        {
          imgs: [putcontent_5, putcontent_6],
          title: "充电立减券广告",
          desc:
            "用户通过移动积分/付费，获得充电立减券包，可在微信支付时使用，存放在微信卡券包里。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner",
            },
            {
              title: "结算方式",
              content: "按CPM/CPA方式结算，多种计费方式",
            },
          ],
        },
        {
          imgs: [putcontent_7, putcontent_8],
          title: "视听会员广告",
          desc:
            "只要以各大影视平台会员为广告内容，用户通过订阅购买，每月可领取多个平台中的一个会员。",
          contents: [
            {
              title: "可投放位置",
              content: "缴费页面弹窗，各页面banner，公众号菜单栏",
            },
            {
              title: "结算方式",
              content: "以CPA方式结算，按购买转化数据进行返佣",
            },
          ],
        },
      ],
      pcSwiper: null,
      advantage:[
        {
          img:advantage_1,
          content:'公司拥有大量广告资源，<br>自有广告有长期投放需求，<br>合作长期稳定；',
          indexIcon:advantage_index_1
        },
        {
          img:advantage_2,
          content:'合作灵活多样，<br>并会在广告位规划、<br> 最大获利等多个方面给予专业建议；',
          indexIcon:advantage_index_2
        },
        {
          img:advantage_3,
          content:'广告投放确定合作后，<br>公司都是预付款方式合作，<br>合作无风险。',
          indexIcon:advantage_index_3
        }
      ]
    };
  },
  components: {
    PCHeader,
    PCFooter,
    Partner,
    Swiper,
    HomeAdvisory
  },
  mounted() {
    this.Pc_Mobile();
    // this.getPageData();
    this.getPartnerList();
    // this.getHeaderImage();
    this.imgSwiper();
    this.titleObj = {
      title: "广告投放合作方案",
      desc:
        "广告内容通过各种渠道和方式传播给目标受众，通过广告的商业效应进行变现，获得广告主的广告费用，是当下各线上互联网平台获取增值收益的方式之一，通过长期投放，收获稳定的广告收益。",
    };
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_AdPutting");
      } else {
        this.$router.push("/AdPutting");
      }
    },
    getPartnerList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/cooperative",
        null,
        (res) => {
          if (res.code == 1) {
            this.partner = res.data;
          }
        }
      );
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: 1 },
        (res) => {
          //  console.log(res,'qwuioiquwe')
          if (res.code == 1) {
            this.topStyle = "background-image:url('" + res.data.pc_image + "')";
          }
          // console.log(res.data,'qwuioiquwe')
        }
      );
    },
    imgSwiper() {
      const that = this;
      this.$nextTick(() => {
        this.pcSwiper = new Swiper(".ad-swiper-container", {
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: false,
          on: {
            slideChange: function () {
              that.tabIndex = (this.activeIndex - 1) % that.putcontent.length;
            },
          },
        });
      });
    },
    tabClick(index) {
      this.tabIndex = index;
      this.pcSwiper.slideTo(index + 1);
    },
  },
};
</script>
<style lang="stylus" scoped>
img{
  max-width: none;
}
.ad-container{
  padding: 80px 12px;

  .ad-content{
    width: 1400px;
    background: #FFFFFF;
    margin: 0 auto;
  }
}
.write{
  background: #FFFFFF;
}
.ad-title{
  text-align: center;
}
.ad-title h3 {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 2px;
}

.ad-title span {
  display: block;
  margin: 20px auto 0;
  content: '';
  width: 42px;
  height: 4px;
  border-bottom: 2px solid #ffc000;
}

.ad-text {
  text-align: center;
  font-size: 18px;
  margin-top: 20px;
  color: #333333;
}
.cooperation{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 85px;
  .cooperation-item{
    position: relative;
    width: 334px;
    height: 330px;
    background: rgba(255, 192, 0, 0.08);
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    line-height: 1;
    padding: 30px 14px 14px;
    transition: all 0.5s;
    cursor: pointer;
    &:hover{
      transform: translateY(-30px);
    }
    .title{
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      text-align: center;
    }
    .img{
      width: 306px;
      height: 240px;
      margin-top: 26px;
    }
    .index{
      position: absolute;
      top: -20px;
      left: 25px;
      width: 42px;
      height: 33px;

    }
  }
}
.put-in{
  padding: 63px 70px 79px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 60px;
  .item{
  position: relative;

    text-align: center;
    width: 233px;
    transition: all 0.5s;
    cursor: pointer;
    &:hover{
      transform: translateY(-30px);
    }
    .img{
      position: relative;
      width: 100%;
      height: 444px;
      z-index: 1;
    }
    .title{
      position: relative;

      font-weight: bold;
      font-size: 18px;
      color: #333333;
      text-align: center;
      z-index: 1;

    }
    .b-img{
      position: absolute;
      bottom: -53px;
      left: 50%;
      transform: translateX(-50%);
      width: 363px;
      height: 180px;
      z-index: 0;
    }
  }
}
.swiper-tabs{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 45px;
  .tab{
    margin: 0 19px;
    width: 154px;
    height: 46px;
    line-height: 46px;
    background: rgba(255, 192, 0, 0.16);
    border-radius: 23px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    cursor: pointer;
    &.active,&:hover{
      background: #FFC000;
      color: #fff;
      font-weight: bold;
    }
  }
}
.putcontent-item{
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 60px 0 70px;
  .putcontent-bg{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 300px;
    background: #F7F7F7;
  }
  .left{
    position: relative;
    padding: 0 122px 0 150px;
    display: flex;
    justify-content: space-between;
    width: 790px;
    z-index: 1;
    img{
      width: 221px;
      height: 445px;
    }
  }
  .right{
    position: relative;
    z-index: 1;
    width: 100%;
    flex: 1;
    padding: 0 160px 23px 0;
    color: #333333;

    .content-title{
      position: relative;
      font-weight: bold;
      font-size: 22px;
      line-height: 1;
      display: inline-block;
      &::after{
        content: '';
        display: block;
        width: 40px;
        height: 3px;
        background: #FFC000;
        margin-top: 23px;
      }
      span{
        position: relative;
        z-index: 1;
      }
      .dot{
        position: absolute;
        right: -10px;
        top: -10px;
        width: 24px;
        height: 24px;
        background: linear-gradient(235deg, #FFC000 0%, rgba(255,192,0,0) 100%);
        border-radius: 50%;
        opacity: 0.5;
      }
    }
    .desc{
      font-size: 18px;
      margin-top: 50px;
    }
    .c-list{
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      .c-item{
        width: 187px;
        .c-title{
          position: relative;
          font-weight: bold;
          font-size: 18px;
          padding-left: 18px;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #FFC000;
          }
        }
        .c-content{
          font-size: 18px;
          margin-top: 10px;
        }
      }
    }
  }
}
.advantage{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 80px;
  .item{
    position: relative;
    width: 446px;
    height: 300px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185,185,185,0.15);
    border-radius: 4px;
    text-align: center;
    padding-top: 51px;
    &:hover{
      box-shadow: 0px 2px 17px 3px rgba(255,196,58,0.16);
    }
    .img{
      width: 104px;
      height: 92px;
    }
    .advantage-content{
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      margin-top: 30px;
    }
    .index-icon{
      position: absolute;
      top: 31px;
      left: 40px;
      width: 69px;
      height: 47px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/AdPutting.vue